// Section Types for Page Builder
export interface SectionConfig {
    id: string
    type: 'hero' | 'category' | 'tours' | 'vehicles' | 'videos' | 'cta' | 'search' | 'categories' | 'popular' | 'newsletter' | 'ads'
    variant?: string
    config: Record<string, any>
    sticky?: boolean
}

export interface PageLayout {
    page_slug: string
    page_name: string
    layout_config: { sections: SectionConfig[] }
    sidebar_config: { sections: SectionConfig[] }
}

// Section Library - defines available sections and their configurations
export const SECTION_LIBRARY = {
    // Main Content Sections
    hero: {
        name: { en: 'Hero Section', vi: 'Section Hero' },
        icon: '🎯',
        variants: [
            { id: 'featured', name: { en: 'Featured Article', vi: 'Bài nổi bật' } },
            { id: 'slideshow', name: { en: 'Slideshow (Auto)', vi: 'Slideshow tự động' } },
            { id: 'featured-thumbnails', name: { en: 'Featured + Thumbnails', vi: 'Nổi bật + Ảnh nhỏ' } },
        ],
        defaultConfig: { source: 'latest', count: 5 }
    },
    category: {
        name: { en: 'Category Section', vi: 'Section Danh mục' },
        icon: '📂',
        variants: [
            { id: 'featured-sidebar', name: { en: 'Featured + Sidebar', vi: 'Nổi bật + Sidebar' } },
            { id: 'grid-3', name: { en: '3 Columns Grid', vi: 'Lưới 3 cột' } },
            { id: 'grid-2', name: { en: '2 Columns Grid', vi: 'Lưới 2 cột' } },
            { id: 'magazine', name: { en: 'Magazine Style', vi: 'Kiểu Tạp chí' } },
            { id: 'list', name: { en: 'List View', vi: 'Dạng danh sách' } },
            { id: 'carousel', name: { en: 'Carousel', vi: 'Carousel' } },
        ],
        defaultConfig: { categorySlug: '', layout: 'featured-sidebar', count: 5, showImage: true }
    },
    tours: {
        name: { en: 'Tours Section', vi: 'Section Tour' },
        icon: '🎫',
        variants: [
            { id: 'cards', name: { en: 'Cards', vi: 'Cards' } },
            { id: 'carousel', name: { en: 'Carousel', vi: 'Carousel' } },
            { id: 'minimal', name: { en: 'Minimal List', vi: 'Danh sách tối giản' } },
        ],
        defaultConfig: { count: 4 }
    },
    vehicles: {
        name: { en: 'Vehicles Section', vi: 'Section Xe' },
        icon: '🏍️',
        variants: [
            { id: 'grid', name: { en: 'Grid', vi: 'Lưới' } },
            { id: 'carousel', name: { en: 'Carousel', vi: 'Carousel' } },
            { id: 'featured', name: { en: 'Featured', vi: 'Nổi bật' } },
        ],
        defaultConfig: { count: 6, columns: 3 }
    },
    videos: {
        name: { en: 'Short Videos', vi: 'Video ngắn' },
        icon: '📹',
        variants: [
            { id: 'horizontal', name: { en: 'Horizontal Scroll', vi: 'Cuộn ngang' } },
            { id: 'grid', name: { en: 'Grid', vi: 'Lưới' } },
            { id: 'stories', name: { en: 'Stories Style', vi: 'Kiểu Stories' } },
        ],
        defaultConfig: { count: 5 }
    },

    // Sidebar Sections
    search: {
        name: { en: 'Search Box', vi: 'Ô tìm kiếm' },
        icon: '🔍',
        variants: [],
        defaultConfig: {}
    },
    categories: {
        name: { en: 'Categories List', vi: 'Danh sách danh mục' },
        icon: '📁',
        variants: [],
        defaultConfig: { showCount: true }
    },
    popular: {
        name: { en: 'Popular Posts', vi: 'Bài viết phổ biến' },
        icon: '🔥',
        variants: [],
        defaultConfig: { count: 5 }
    },
    newsletter: {
        name: { en: 'Newsletter', vi: 'Đăng ký email' },
        icon: '✉️',
        variants: [],
        defaultConfig: {}
    },
    cta: {
        name: { en: 'Call to Action', vi: 'Nút kêu gọi' },
        icon: '🎯',
        variants: [
            { id: 'orange-red', name: { en: 'Orange to Red', vi: 'Cam sang Đỏ' } },
            { id: 'blue-purple', name: { en: 'Blue to Purple', vi: 'Xanh sang Tím' } },
            { id: 'green', name: { en: 'Green', vi: 'Xanh lá' } },
        ],
        defaultConfig: { title: 'Book Now!', link: '/tours', gradient: 'orange-red' }
    },
    ads: {
        name: { en: 'Advertisement', vi: 'Quảng cáo' },
        icon: '📢',
        variants: [
            { id: 'banner', name: { en: 'Banner', vi: 'Banner' } },
            { id: 'custom-html', name: { en: 'Custom HTML/JS', vi: 'HTML/JS tùy chỉnh' } },
        ],
        defaultConfig: { html: '', imageUrl: '', link: '' }
    },
}

export type SectionType = keyof typeof SECTION_LIBRARY
